module.exports = __webpack_public_path__ + "static/media/NZ.5be99e9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/NZ.svg
// module id = 333
// module chunks = 0